/**
 * Created by Jerker Nord on 2022-10-28.
 */

export class LonerStatics {

    public static MAX_WIN_TRIGGER: string = "Max Win";
    public static MAX_WIN_TEASE_TRIGGER: string = "Max Win Tease";

    public static SCATTER_ANTICIPATION_DELAY_NORMAL: number = 1.5;
    public static SCATTER_ANTICIPATION_DELAY_FAST: number = 0.75;
    public static SCATTER_ANTICIPATION_DELAY_LUCKY_DRAW: number = 1.75;
    public static REEL_NUMBERS: number = 5;

    public static defaultGameAreaSize: number[] = [3, 3, 3, 3, 3];
    public static symbolWidth: number = 144;
    public static symbolHeight: number = 130;
    public static spinSymbolHeight: number = 160;
    //Height of symbols
    public static stepSize: number = 130;
    public static spinStepSize: number = 140;
    public static stepDuration: number = 0.10;
    public static spinStepDurationNormal: number = 0.05;

    //Spin start
    public static betweenReelsStartDelayNormal: number[] = [0, 0.02, 0.04, 0.06, 0.8];//0, 0.02, 0.05, 0.08, 0.12
    public static betweenReelsStartDelayFast: number[] = [0, 0.001, 0.002, 0.003, 0.004];
    public static NORMAL_START_SPIN_BOUNCE_DURATION_FACTOR: number = 0.06;
    public static NORMAL_START_SPIN_BOUNCE_PIXELS: number = 20;
    public static NORMAL_START_SPIN_ACCELERATOR_FACTOR: number = LonerStatics.spinStepDurationNormal * 2.5;
    public static NORMAL_BLUR_DELAY_SPIN_START: number = 0.01;
    public static NORMAL_BLUR_DURATION_SPIN_START: number = LonerStatics.spinStepDurationNormal * 0.8;//1.6

    public static FAST_START_SPIN_BOUNCE_FACTOR: number = 0.1;
    public static FAST_START_SPIN_BOUNCE_DURATION_FACTOR: number = 1.2;
    public static FAST_START_SPIN_ACCELERATOR_FACTOR: number = 0.08;
    public static FAST_BLUR_DELAY_SPIN_START: number = 0;
    public static FAST_BLUR_DURATION_SPIN_START: number = 0.1;

    //Spin stop
    public static reelStopDelayNormal: number[] = [0, 0.20, 0.20, 0.20, 0.16];
    public static reelStopDelayFastSpin: number[] = [0, 0.0001, 0.0001, 0.0001, 0.0001];

    public static STOP_SPIN_STOP_ADJUST_DURATION: number = 0.10;
    public static STOP_SPIN_BOUNCE_PIXEL_AMOUNT: number = 8;
    public static STOP_SPIN_BOUNCE_DURATION: number = 0.18;
    public static STOP_SPIN_BOUNCE_BACK_DURATION: number = 0.09;
    public static BLUR_DELAY_SPIN_STOP: number = 0.02;
    public static BLUR_DURATION_SPIN_STOP: number = 0.09;

    public static spinStepDurationFast: number = 0.03;
    public static spinStartDurationFast: number = 0.120;
    public static BLUR_DELAY_SPIN_START_FAST: number = 0.01;
    public static BLUR_DURATION_SPIN_START_FAST: number = 0.07;
    public static STOP_SPIN_BOUNCE_BACK_FAST_DURATION: number = 0.0001;
    public static STOP_SPIN_BOUNCE_FAST_PIXEL_AMOUNT: number = 0.0001;
    public static STOP_SPIN_STOP_ADJUST_FAST_DURATION: number = 0.0001;
    public static BLUR_DELAY_SPIN_STOP_FAST: number = 0.001;
    public static BLUR_DURATION_SPIN_STOP_FAST: number = 0.001;

    public static X_SPLIT_ATTENTION_REEL_DELAY: number = 0.6;
    public static MAIN_REELS_VIEW_POSITION: PIXI.Point = new PIXI.Point(71, -70);
    public static MAIN_REELS_VIEW_MASK_POSITION: PIXI.Point = new PIXI.Point(-102, 194);
    public static SYMBOLS: string[] = ["L1", "L2", "L3", "L4", "L5", "M1", "M2", "M3", "M4", "M5"];

    public static reelPositions: PIXI.Point[] = [
        new PIXI.Point(LonerStatics.symbolWidth * 0, 0 - LonerStatics.symbolHeight),
        new PIXI.Point(LonerStatics.symbolWidth * 1, 0 - LonerStatics.symbolHeight),
        new PIXI.Point(LonerStatics.symbolWidth * 2, 0 - LonerStatics.symbolHeight),
        new PIXI.Point(LonerStatics.symbolWidth * 3, 0 - LonerStatics.symbolHeight),
        new PIXI.Point(LonerStatics.symbolWidth * 4, 0 - LonerStatics.symbolHeight),
        new PIXI.Point(LonerStatics.symbolWidth * 5, 0 - LonerStatics.symbolHeight)
    ];

    //below info is for win animation related to symbols
    public static SEQ_WIN_ANIM_DURATION: number = 1;
    public static SEQ_WIN_FRAME_ALPHA: number[] = [0.4, 0.6, 0.8, 1.0]; // value range between 0 to 1 like 0.5 reel wise
    public static PRE_WIN_ANIM_DURATION: number = 0.3;
    public static PRE_WIN_FRAME_ALPHA: number[] = [0.3, 0.3, 0.5, 0.7, 1.0]; // value range between 0 to 1 like 0.5 reel wise

    public static WIN_HIGHLIGHT_ANIM_DURATION: number = 0.42;
    public static WIN_HIGHLIGHT_FRAME_ALPHA: number = 0.5;
    public static PRE_WIN_FRAME_TINT: number[][] = [
        [
            PIXI.utils.string2hex("#FFFFFF"), //M1
            PIXI.utils.string2hex("#FFFFFF"), //M2
            PIXI.utils.string2hex("#FFFFFF"), //M3
            PIXI.utils.string2hex("#FFFFFF"), //M4
            PIXI.utils.string2hex("#FFFFFF"), //M5
        ],
        [
            PIXI.utils.string2hex("#FFFFFF"), //L1
            PIXI.utils.string2hex("#FFFFFF"), //L2
            PIXI.utils.string2hex("#FFFFFF"), //L3
            PIXI.utils.string2hex("#FFFFFF"), //L4
            PIXI.utils.string2hex("#FFFFFF"), //L5
        ],
        [
            PIXI.utils.string2hex("#FFFFFF"), //NUDGE
        ]
    ];
    public static SEQ_WIN_FRAME_TINT: number[][] = [
        [
            PIXI.utils.string2hex("#FFFFFF"), //M1
            PIXI.utils.string2hex("#FFFFFF"), //M2
            PIXI.utils.string2hex("#FFFFFF"), //M3
            PIXI.utils.string2hex("#FFFFFF"), //M4
            PIXI.utils.string2hex("#FFFFFF"), //M5
        ],
        [
            PIXI.utils.string2hex("#FFFFFF"), //L1
            PIXI.utils.string2hex("#FFFFFF"), //L2
            PIXI.utils.string2hex("#FFFFFF"), //L3
            PIXI.utils.string2hex("#FFFFFF"), //L4
            PIXI.utils.string2hex("#FFFFFF"), //L5
        ],
        [
            PIXI.utils.string2hex("#FFFFFF"), //NUDGE
        ],
        [
            PIXI.utils.string2hex("#FFF177"), //W
        ]
    ];

    // xWays and xSplit stuff
    public static XWAYS_XSPLIT_NO_WIN_TINT: number = PIXI.utils.string2hex("#555555");
    public static XWAYS_FRAME_TINT: number = PIXI.utils.string2hex("#FFF177");
    public static XSPLIT_FRAME_TINT: number = PIXI.utils.string2hex("#FFF177");

    //bigWild
    public static WILD_2X2_STRING: string = "W2";
    public static WILD_3X3_STRING: string = "W3";
    public static WILD_STRING: string = "W"

    public static DUCK_SYMBOLS_LEFT: string[] = ["duck_syms/ammo_left", "duck_syms/bomb_left", "duck_syms/M1_left", "duck_syms/M2_left", "duck_syms/M3_left", "duck_syms/M4_left", "duck_syms/M5_left"];
    public static DUCK_SYMBOLS_RIGHT: string[] = ["duck_syms/ammo_right", "duck_syms/bomb_right", "duck_syms/M1_right", "duck_syms/M2_right", "duck_syms/M3_right", "duck_syms/M4_right", "duck_syms/M5_right"];


    //pin The Win stuff
    public static MOVING_SPEED_PIXELS_PER_SECOND: number = 250;
    public static MOVING_SPEED_PIXELS_PER_SECOND_FAST_SPIN: number = 350;
    public static PIN_SYMBOL_HEIGHT:number=(390 / 5) * 1.5;
    public static PIN_SYMBOL_WIDTH:number=((LonerStatics.symbolHeight * 3) / 5) * 1.5;

    public static stagePos:PIXI.Point;

}